import { url } from "./apiBase";

const clientUrl = url + 'client/'

const CustomerRoutes = {
    Cities:
    {
        GetAll: url + 'config/ciudades/all'
    },
    Shops:
    {
        GetCategories: url + 'categorias/all',
        GetAllShopsByCategory: url + 'categorias/all/', //completar con el ID de la categoria
        GetShopByUUID: url + 'public/smartcard/', //completar con el uuid del comercio
        GetShopCategories: url + 'categorias/all/shop/', //completar con el UUID del comercio
        GetShopProductsByCategory: url + 'categorias/all/shop/', //completar con uuid del comercio y uuid de la categoria
    },
    Commerce:{
        Cart:{
            GetAll : url + 'commerce/cart',
            AddItem: url + 'commerce/cart/add',
            UpdateItemQuantity: (id) => url + `commerce/cart/item/${id}`,
            RemoveItem: (id) => url + `commerce/cart/item/${id}`,
            SyncGuest: url + 'commerce/cart/sync',
            Checkout: url + 'commerce/checkout'
        },
    },
    LOGISTICS:{
        CALCULATE_QUOTES: url + 'delivery/calculate'
    },
    ShoppingCar:{
        AddProduct: url + 'carrito/agregar',
        SearchProduct: url + 'carrito/search/', //completar con el ID del Producto
        GetTotals: url + 'carrito/totales',
        Checkout: url + 'carrito/checkout',
        Details:
        {
            Delete: url + 'carrito/detalle/eliminardetalle',
            ByMerchantID: url + 'carrito/detalle/', //completar con el id del negocio
        }
    },
    Reviews:
    {
        MakeReview: url + 'reviews/create',
    },
    SocialNetwork:
    {
        GetAll: url +'public/redsocial/',
    },
    Products:
    {
        GetProductByUUID: url + 'public/product/', //completar con el UUID
    },
    Events:
    {
        GetAll: url + 'public/events',
        GetEventByID: url + 'public/events/show/', //completar con el ID o el UUID del evento
        GetEventCategories: url + 'public/events/categories',
        GetEventByCategory: url + 'public/events/category/', //completar con el ID de la categoria
        Tickets:
        {
            Buy: url + 'comercios/pedido/boleto',
            Purchased: url + 'clientes/tickets',
            PurchasedByEvent: url + 'clientes/tickets/evento/', //completar con el ID del evento
            GetTicket: url + 'public/events/ticketing/', //completar con el uuid del boleto
            GetList: url + 'eventos/tickets/list/customer'
        }
    },
    Subscriptions:
    {
        getAll : url + 'client/subscriptions',
        show: (id) => url + `client/subscriptions/${id}`,
        //pay: url + `client/subscriptions/pay-order/`,
    },
    Coupons:
    {
        GetAll: url + 'coupons/allFromCustomer',
        PreloadedCoupon: url + 'public/coupons/free/',//completar con el uuid del cupon precargado
    },
    Orders:
    {
        MyOrders: (group='all',page=1) => url + `client/orders/my-orders?group=${group}&page=${page}`,
        Detail: (id) => url + `client/orders/${id}`,
        GetAll: url + 'clientes/pedidos/tipo_pedido/', //completar con el tipo_pedido
        GetDetails: url + 'clientes/pedidos/detalles/', //completar con el codigo del pedido
        TaxiOrder: url + 'clientes/pedidos/crear/taxi',
    },
    Bookings:{
        MyBookings: (group='upcoming',page=1) => url + `client/bookings/my-bookings?group=${group}&page=${page}`
    },
    Payments:
    {
        order: url + `client/payments/pay-order`,
        multipleOrders: url + `client/payments/pay-multiple-orders`
    },
    Reservations:
    {
        GetAll: url + 'clientes/reservations',
        Create: url + 'clientes/reservations/create',
    },
    Wallet:
    {
        Deposit: url + 'wallet/transaction/depositar',
        DepositWithoutLogin: url + 'public/wallet/transaction/depositar',
        PayWithoutPin: url + 'wallet/transaction/pagarsinpin',
        PayWithoutLogin: url + 'public/wallet/transaction/pagarsl',
        PaymentProcess: url + 'payment/process'
    },
    Profile:
    {
        Index: url + 'clientes/profile',
        Update: url + 'clientes/profile/update',
        UpdateImages: url + 'clientes/profile/updateimages',
    },
    Workspaces:{
        GetAll: clientUrl+`workspaces`,
        GetEvents: (merchantUuid) => clientUrl+`workspaces/${merchantUuid}/events`
    }
};


export default CustomerRoutes;